module.exports = __webpack_public_path__ + "static/media/locationGreen.4598043c.svg";